import { render } from "./DefSlideModal.vue?vue&type=template&id=3c8c76ea&scoped=true"
import script from "./DefSlideModal.vue?vue&type=script&lang=js"
export * from "./DefSlideModal.vue?vue&type=script&lang=js"

import "./DefSlideModal.vue?vue&type=style&index=0&id=3c8c76ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8c76ea"]])

export default __exports__